import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { loadMsalConfig } from "./msalConfig";

let msalInstance;
export async function initMsal() {
  try {
    const config = await loadMsalConfig();
    // console.log("config", config);

    if (!config?.auth?.clientId) {
      throw new Error("MSAL config is missing clientId");
    }
    msalInstance = new PublicClientApplication(config);

    // Default active account setup
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
    // Event callback
    msalInstance.addEventCallback(event => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        msalInstance.setActiveAccount(event.payload.account);
      }
    });

    return msalInstance;
  } catch (error) {
    console.error("initMsal failed: ", error);
    if (typeof window !== "undefined") {
      window.location.href = `${process.env.REACT_APP_REDIRECT_URI}/error`;
    }
  }
}
export function getMsalInstance() {
  if (!msalInstance) {
    throw new Error("MSAL has not been initialized yet!");
  }
  return msalInstance;
}
